import type { LiveLectureMeetingLinkDto } from "../interfaces/live-lecture/live-lecture.dto";

const JOIN_HASH_PREFIX = "#s=";

export type CallJoinSession = LiveLectureMeetingLinkDto & {
  title?: string;
  returnUrl: string;
  locale?: string;
  theme?: string;
  apiBaseUrl?: string;
  apiToken?: string;
  platformKey?: string;
  hostProfile?: {
    id?: string;
    name?: string;
    profilePhoto?: string;
  };
};

function toBase64Url(value: string): string {
  return btoa(value)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");
}

export function encodeCallJoinSession(session: CallJoinSession): string {
  return toBase64Url(
    encodeURIComponent(JSON.stringify(session)).replace(/%([0-9A-F]{2})/g, (_, hex) =>
      String.fromCharCode(Number.parseInt(hex, 16)),
    ),
  );
}

export function buildCallJoinUrl(
  callAppBaseUrl: string,
  session: CallJoinSession,
): string {
  const base = callAppBaseUrl.replace(/\/$/, "");
  return `${base}/join${JOIN_HASH_PREFIX}${encodeCallJoinSession(session)}`;
}

export function getCallAppUrl(): string | null {
  const value = process.env.REACT_APP_CALL_APP_URL?.trim();
  return value || null;
}
